<template>
  <div class="scroll-container">
    <div class="load">
      <span v-if="hasMore" class="el-icon-loading load-icon"></span>
      <span>{{ hasMore ? "正在加载中..." : "没有更多数据了" }}</span>
    </div>
  </div>
</template>

<script>
const throttle = function(fn, delay) {
  let timer = null
  return function (...args) {
    clearTimeout(timer)
    timer = setTimeout(() => fn.apply(this, [...args]), delay)
  }
}
export default {
  props: {
    threshold: {
      // 到达底部多少距离的时候开始请求数据
      type: Number,
      default: 0,
    },
    hasMore: {
      // 是否还需要请求
      type: Boolean,
      default: false,
    },
    loadMoreFn: {
      // 发起请求的函数
      type: Function,
      default: () => {},
    },
    el: {
      // 限制在el元素内部滚动,如果不传el,则默认浏览器滚动条
      type: String,
      default: null,
    },
    doing: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
		// doing: null
	};
  },
  mounted() {
    if (this.el) {
      nextTick(() => {
        const el = document.querySelector(this.el);
        if (el) {
          el.addEventListener("scroll", this.scroll)
        }
      });
    } else {
      window.addEventListener("scroll", this.scroll, true);
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.scroll, true)
  },
  methods: {
    scroll: throttle(function(){
        if(this.doing) return false
        // let el = document.body
        // if (this.el) {
        //   el = document.querySelector(this.el)
        // }
        const threshold = this.threshold || 30
        // let scrollTop = this.el ? el.scrollTop : (el.scrollTop || document.documentElement.scrollTop || window.pageXOffset);
        // const docHeight = el.scrollHeight - (this.el ? el.offsetHeight : window.innerHeight)
        // if ((docHeight < (scrollTop + threshold)) && this.hasMore) {
        if (this.getScrollHeight() - this.getClientHeight() - this.getScrollTop() <= threshold && this.hasMore) {
        // 防止滚动过程中重复触发请求
          if (!this.doing) {
            // this.doing = true
            this.loadMoreFn()
          }
        }
    }, 300),
    // 获取滚动条当前的位置
    getScrollTop () {
      let scrollTop = 0
      if (document.documentElement && document.documentElement.scrollTop) {
        scrollTop = document.documentElement.scrollTop
      } else if (document.body) {
        scrollTop = document.body.scrollTop
      }
      return scrollTop
    },
    // 获取当前可视范围的高度
    getClientHeight () {
      var clientHeight = 0
      if (document.body.clientHeight && document.documentElement.clientHeight) {
        clientHeight = Math.min(document.body.clientHeight, document.documentElement.clientHeight)
      } else {
        clientHeight = Math.max(document.body.clientHeight, document.documentElement.clientHeight)
      }
      return clientHeight
    },
    // 获取文档完整的高度
    getScrollHeight () {
      return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight)
    },
  }
}
</script>

<style lang="scss" scoped>
.scroll-container {
  display: flex;
  background: #f5f5f5;
  justify-content: center;
  align-items: center;
  height: 50px;
  .load {
    span {
      font-size: 14px;
      color: #969696;
      font-weight: 500;
      &:first-of-type {
        margin-right: 10px;
      }
    }
  }
}
</style>
